import { EditPencilButton } from "../../../../Common/Components/EditPencilButton";
import FormField from "../../register/components/FormField";

function Step1BusinessInfo({
  formData,
  errors,
  handleChange,
  cityOptions,
  BUSINESS_TYPE_OPTIONS,
  readOnly = false,
}) {
  return (
    <div className="step1-form">
      <div className="step1-form-row">
        <FormField
          label="I am a"
          name="businessType"
          type="select"
          value={formData.businessType}
          onChange={handleChange}
          error={errors.businessType}
          placeholder="Select Vendor or Venue"
          required
          options={BUSINESS_TYPE_OPTIONS}
          disabled={readOnly}
          icon={
            <>
              <rect
                x="2"
                y="7"
                width="20"
                height="14"
                rx="2"
                ry="2"
                stroke="currentColor"
                strokeWidth="2"
                fill="none"
              />
              <path
                d="M16 21V5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v16"
                stroke="currentColor"
                strokeWidth="2"
                fill="none"
              />
            </>
          }
        />
        <FormField
          label="City"
          name="city"
          type="select"
          value={formData.city}
          onChange={handleChange}
          error={errors.city}
          placeholder="Select City"
          required
          options={cityOptions}
          disabled={readOnly}
          icon={
            <path
              d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"
              stroke="currentColor"
            />
          }
        />
      </div>
      <div className="step1-form-row">
        <FormField
          label="Name"
          name="name"
          value={formData.name}
          onChange={handleChange}
          error={errors.name}
          placeholder="Enter your name"
          required
          disabled={readOnly}
          icon={
            <>
              <path
                d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"
                stroke="currentColor"
                strokeWidth="2"
                fill="none"
              />
              <circle
                cx="12"
                cy="7"
                r="4"
                stroke="currentColor"
                strokeWidth="2"
                fill="none"
              />
            </>
          }
          rightIcon={<EditPencilButton fieldName="name" />}
        />
        <FormField
          label="Phone"
          name="phone"
          type="tel"
          value={formData.phone}
          onChange={handleChange}
          error={errors.phone}
          placeholder="10-digit mobile number"
          required
          disabled={readOnly}
          icon={
            <path
              d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"
              stroke="currentColor"
            />
          }
          rightIcon={<EditPencilButton fieldName="phone" />}
        />
      </div>
      <FormField
        label="Email"
        name="email"
        type="email"
        value={formData.email}
        onChange={handleChange}
        error={errors.email}
        placeholder="Enter your email"
        required
        disabled={true}
        icon={
          <path
            d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"
            stroke="currentColor"
          />
        }
      />
      <div className="step1-form-row">
        {(formData?.businessType === "vendor"||formData?.businessType === "venue") && (
          <FormField
            label= { formData?.businessType === "vendor" ? "Starting Package Price (₹)" : "Price Per Plate (₹)"}
            name="price_min"
            type="number"
            value={formData.price_min}
            onChange={handleChange}
            error={errors.price_min}
            placeholder="0"
            required
            disabled={readOnly}
            icon={
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 24 24"
                width="24"
                height="24"
                fill="currentColor"
              >
                <path d="M13.66 7H19V5H5v2h6.34c1.5 0 2.74 1.08 3.06 2.5H5v2h9.4c-.34 1.44-1.64 2.5-3.24 2.5H5v2h5.6l4.4 5h2.6l-4.6-5.2c2.24-.3 4-2.06 4.4-4.3H19v-2h-1.2c-.4-2.52-2.58-4.5-5.14-4.5z" />
              </svg>
            }
          />
        )}
        {formData?.businessType === "venue" && (
          <FormField
            label="Maximum price (₹)"
            name="price_max"
            type="number"
            value={formData.price_max}
            onChange={handleChange}
            error={errors.price_max}
            placeholder="0"
            required
            disabled={readOnly}
            icon={
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 24 24"
                width="24"
                height="24"
                fill="currentColor"
              >
                <path d="M13.66 7H19V5H5v2h6.34c1.5 0 2.74 1.08 3.06 2.5H5v2h9.4c-.34 1.44-1.64 2.5-3.24 2.5H5v2h5.6l4.4 5h2.6l-4.6-5.2c2.24-.3 4-2.06 4.4-4.3H19v-2h-1.2c-.4-2.52-2.58-4.5-5.14-4.5z" />
              </svg>
            }
          />
        )}
      </div>
    </div>
  );
}

export default Step1BusinessInfo;
